import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, Beer } from "lucide-react";
import { useAdminAuth } from "../../lib/adminAuth";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/admin", { replace: true });
    } catch (ex) {
      const detail = ex?.response?.data?.detail;
      setErr(typeof detail === "string" ? detail : "No pudimos iniciarte sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-panel min-h-screen bg-black flex items-center justify-center p-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 mb-3">
            <Beer size={32} className="text-[#FEBA01]" />
            <div className="font-display text-4xl uppercase tracking-tight">Kiltro Admin</div>
          </div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#A3A3A3]">
            Ruta cervecera · Panel
          </p>
        </div>

        <form
          onSubmit={submit}
          className="bg-[#1A1A1A] border-2 border-[#FEBA01] p-6 shadow-brutal space-y-4"
        >
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-[#A3A3A3] mb-1">
              Email
            </label>
            <div className="flex items-center bg-[#0A0A0A] border-2 border-[#333] focus-within:border-[#FEBA01]">
              <Mail size={16} className="text-[#FEBA01] ml-3" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent outline-none px-3 py-2 text-[#F5F5F5]"
                placeholder="admin@kiltroscout.cl"
                autoFocus
                data-testid="admin-email-input"
              />
            </div>
          </div>
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-[#A3A3A3] mb-1">
              Clave
            </label>
            <div className="flex items-center bg-[#0A0A0A] border-2 border-[#333] focus-within:border-[#FEBA01]">
              <Lock size={16} className="text-[#FEBA01] ml-3" />
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent outline-none px-3 py-2 text-[#F5F5F5]"
                data-testid="admin-password-input"
              />
            </div>
          </div>
          {err && (
            <div className="text-sm text-red-400 border border-red-500/40 bg-red-500/10 p-2" data-testid="admin-login-error">
              {err}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="btn-brutal w-full bg-[#FEBA01] text-black font-display text-lg uppercase py-3 shadow-brutal-white disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            {loading ? "Validando…" : "Entrar"}
          </button>
        </form>

        <div className="text-center mt-6 font-mono text-[10px] uppercase tracking-widest text-[#666]">
          © 2026 Kiltro Scout
        </div>
      </div>
    </div>
  );
}
